// Import does really matter, it's the reference in source code
import highchartsPluginRegistry from "../HighchartsPluginRegistry"
import montaigneYAxisPlugin from "./montaigneYAxisPlugin"
import montaigneRangeSelectorPlugin from "./montaigneRangeSelectorPlugin"
import montaignePlotOptionsPlugin from "./montaignePlotOptionsPlugin"
import { clearWidgetPlugins, registerWidgetPlugins } from "./widgetPlugin"

/**
 * A hooks to register customer specific plugin to render Highcharts component.<br />
 *
 * Support plugins are, see api reference for usage:
 *    - chartPlugin: https://api.highcharts.com/highstock/chart
 *    - legendPlugin: https://api.highcharts.com/highstock/legend
 *    - xAxisPlugin: https://api.highcharts.com/highstock/xAxis
 *    - yAxisPlugin: https://api.highcharts.com/highstock/yAxis
 *    - disableNavigator: https://api.highcharts.com/highstock/navigator
 *    - rangeSelectorPlugin: https://api.highcharts.com/highstock/rangeSelector
 *    - plotOptionsPlugin: https://api.highcharts.com/highstock/plotOptions
 *    - tooltipPlugin:
 *    - miscellaneousPlugin: concerns all the other properties<br /><br />
 *
 *  Those plugin keywords are reserved by original implementations.
 *  <b>Create a new plugin file with that name will erased the default behaviour.</b>
 *
 *  A default plugin configuration is provided, for each of those plugin. See sources packages/webportal-frontend/src/component/widgets/chart/plugin. <br /><br />
 *
 *  A plugin export a default function that take <b>Highchart's configuration</b> and apply some modifications on that configuration
 *  The plugin function should return the Highchart's configuration. For example for xAxis:
 *  <pre>
 *     // make sure that you'll add all needed import here
 *     // for exemple if you're using lodash
 *     import _ from "lodash"
 *
 *     export default function xAxisPlugin(chartOpts) {
 *           // set (or unset) some specific properties here from backend JUMP Generation
 *           // and return modified options
 *
 *           _.set(xAxix, "lineColor", "#e8e8e8")
 *           _.set(xAxix, "lineWidth", 1)
 *           return chartOpts
 *       }
 *  </pre>
 */
export function registerCustomerPlugin() {
  highchartsPluginRegistry.register("yAxisPlugin", montaigneYAxisPlugin)
  highchartsPluginRegistry.register(
    "rangeSelectorPlugin",
    montaigneRangeSelectorPlugin
  )
  highchartsPluginRegistry.register(
    "plotOptionsPlugin",
    montaignePlotOptionsPlugin
  )
}

export function registerCustomerWidgetPlugin() {
  registerWidgetPlugins()
}

/**
 * Clear functions should remove all registered specific customer.
 */
export function clearCustomerPlugin() {
  highchartsPluginRegistry.remove("yAxisPlugin")
  highchartsPluginRegistry.remove("rangeSelectorPlugin")
}

export function clearCustomerWidgetPlugin() {
  clearWidgetPlugins()
}
